var _excluded = ["contentWidth", "trigger", "children", "onTriggerClick", "triggerClassName", "triggerStyles"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from "prop-types";
import React from "react";
import ToolTip2 from "./tooltip-2";
import PlainButton from "../elements/plain-button";
import uuid from "uuid/v4";

var ButtonTooltip = function ButtonTooltip(_ref) {
  var _ref$contentWidth = _ref.contentWidth,
      contentWidth = _ref$contentWidth === void 0 ? "auto" : _ref$contentWidth,
      trigger = _ref.trigger,
      children = _ref.children,
      onTriggerClick = _ref.onTriggerClick,
      triggerClassName = _ref.triggerClassName,
      triggerStyles = _ref.triggerStyles,
      rest = _objectWithoutProperties(_ref, _excluded);

  // useRef so it only runs once
  // makes screen reader will associate tooltip button w/ content and read it
  var described_by = React.useRef("tooltip-" + uuid());
  return /*#__PURE__*/React.createElement(ToolTip2, _extends({
    contentWidth: contentWidth,
    trigger: /*#__PURE__*/React.createElement(PlainButton, {
      style: triggerStyles,
      onClick: onTriggerClick,
      className: triggerClassName,
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter") onTriggerClick();
      }
    }, trigger)
  }, rest), /*#__PURE__*/React.createElement("div", {
    id: described_by.current
  }, children));
};

ButtonTooltip.propTypes = {
  contentWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  trigger: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.any,
  onTriggerClick: PropTypes.func,
  triggerClassName: PropTypes.string,
  triggerStyles: PropTypes.object
};
export default ButtonTooltip;